// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CardRadioController from "./card_radio_controller"
import CalorieCalculatorController from "./calorie_calculator_controller"
import FoodAutocompleteController from "./food_autocomplete_controller"
import HelloController from "./hello_controller"
import InstallGuideController from "./install_guide_controller"
import MealTimeController from "./meal_time_controller"
import MealTabsController from "./meal_tabs_controller"
import MultiStepFormController from "./multi_step_form_controller"
import OnboardingWeightController from "./onboarding_weight_controller"
import PwaInstallStateController from "./pwa_install_state_controller"

application.register("card-radio", CardRadioController)
application.register("calorie-calculator", CalorieCalculatorController)
application.register("food-autocomplete", FoodAutocompleteController)
application.register("hello", HelloController)
application.register("install-guide", InstallGuideController)
application.register("meal-time", MealTimeController)
application.register("meal-tabs", MealTabsController)
application.register("multi-step-form", MultiStepFormController)
application.register("onboarding-weight", OnboardingWeightController)
application.register("pwa-install-state", PwaInstallStateController)
